module.exports = __webpack_public_path__ + "static/media/fugl.3b3cbe7c.mp3";